exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fields {\n  margin-left: 1.2rem; }\n  .fields i {\n    color: #aaa;\n    font-size: 0.8em;\n    margin-right: 0.2rem; }\n  .fields .field-type {\n    margin-left: 0.3rem;\n    color: #aaa; }\n    .fields .field-type:before {\n      content: '['; }\n    .fields .field-type:after {\n      content: ']'; }\n", ""]);

// exports
